import React from 'react';
import { Plus } from 'lucide-react';
import TaskCard from './TaskCard';
import ColumnHeader from './ColumnHeader';

const TaskColumn = ({
  column,
  tasks,
  firstNonAiColumnName,
  onAddTask,
  onTaskClick,
  onApplyTask,
  onMoveTaskToColumn,
  onRenameColumn,
  onChangeColumnColor,
  onDeleteColumn,
  onColumnDragHandlePointerDown,
}) => {
  const isAI = column.is_ai_suggestions;
  const isEmpty = tasks.length === 0;

  return (
    <div
      data-column-id={column.id}
      className="w-[280px] flex-shrink-0 bg-white rounded-xl shadow-[0_2px_12px_rgba(0,0,0,0.08)] flex flex-col border border-gray-100"
      style={{ height: 'calc(100% - 16px)' }}
    >
      <ColumnHeader
        column={column}
        taskCount={tasks.length}
        firstNonAiColumnName={firstNonAiColumnName}
        onRename={(name) => onRenameColumn(column.id, name)}
        onChangeColor={(color) => onChangeColumnColor(column.id, color)}
        onDelete={() => onDeleteColumn(column.id)}
        onDragHandlePointerDown={onColumnDragHandlePointerDown}
      />

      <div className="flex-1 overflow-y-auto p-2">
        {isEmpty ? (
          isAI ? (
            <div className="flex items-center justify-center h-32 text-gray-400 text-sm text-center px-3">
              AI hasn't generated suggestions for this brand yet.
            </div>
          ) : (
            <button
              onClick={onAddTask}
              className="w-full flex flex-col items-center justify-center h-32 text-gray-400 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition-colors text-sm gap-1"
            >
              <Plus size={20} />
              <span>Add task</span>
            </button>
          )
        ) : (
          <>
            {tasks.map((task) => (
              <TaskCard
                key={task.id}
                task={task}
                onTaskClick={() => onTaskClick(task)}
                onApply={() => onApplyTask(task.id)}
                onMoveToColumn={onMoveTaskToColumn}
              />
            ))}
            {!isAI && (
              <button
                onClick={onAddTask}
                className="w-full flex items-center justify-center gap-1 py-2 text-gray-400 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition-colors text-sm"
              >
                <Plus size={14} />
                <span>Add task</span>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TaskColumn;
